import {z} from 'zod';

// POST /v1/service-inspections/create-new-request-to-basket
// Used when creating request from SC create (no service_order_id)

export const PostHyundaiServiceInspectionCreateNewRequestToBasketApiArgSchema = z.object({
  body: z.object({
    inspectionId: z.array(z.string().nullable()),
    serviceCaseId: z.string().nullable(),
  }),
});

export type PostHyundaiServiceInspectionCreateNewRequestToBasketApiArg = z.infer<
  typeof PostHyundaiServiceInspectionCreateNewRequestToBasketApiArgSchema
>;

export const PostHyundaiServiceInspectionCreateNewRequestToBasketApiResponseSchema = z.void();

export type PostHyundaiServiceInspectionCreateNewRequestToBasketApiResponse = z.infer<
  typeof PostHyundaiServiceInspectionCreateNewRequestToBasketApiResponseSchema
>;

// POST /v1/service-inspections/create-new-request-to-service-order
// Used when creating request from SC detail (with service_order_id)

export const PostHyundaiServiceInspectionCreateNewRequestToServiceOrderApiArgSchema = z.object({
  body: z.object({
    inspectionId: z.array(z.string().nullable()),
    serviceCaseId: z.string().nullable(),
    serviceOrderId: z.string().nullable(),
  }),
});

export type PostHyundaiServiceInspectionCreateNewRequestToServiceOrderApiArg = z.infer<
  typeof PostHyundaiServiceInspectionCreateNewRequestToServiceOrderApiArgSchema
>;

export const PostHyundaiServiceInspectionCreateNewRequestToServiceOrderApiResponseSchema = z.void();

export type PostHyundaiServiceInspectionCreateNewRequestToServiceOrderApiResponse = z.infer<
  typeof PostHyundaiServiceInspectionCreateNewRequestToServiceOrderApiResponseSchema
>;

// GET /v1/service-inspections/mileages

export const GetHyundaiServiceInspectionMileagesApiArgSchema = z.object({
  vehicleId: z.string(),
});

export type GetHyundaiServiceInspectionMileagesApiArg = z.infer<
  typeof GetHyundaiServiceInspectionMileagesApiArgSchema
>;

export const GetHyundaiServiceInspectionMileagesApiResponseSchema = z
  .object({
    mileage_from: z.number().nullable().optional(),
    milleage_to: z.number().nullable().optional(),
  })
  .nullable();

export type GetHyundaiServiceInspectionMileagesApiResponse = z.infer<
  typeof GetHyundaiServiceInspectionMileagesApiResponseSchema
>;

// GET /v1/service-inspections/models

export const GetHyundaiServiceInspectionModelsApiArgSchema = z.object({});

export type GetHyundaiServiceInspectionModelsApiArg = z.infer<
  typeof GetHyundaiServiceInspectionModelsApiArgSchema
>;

export const GetHyundaiServiceInspectionModelsApiResponseSchema = z
  .object({
    model: z.array(z.string().nullable()).optional(),
  })
  .nullable();

export type GetHyundaiServiceInspectionModelsApiResponse = z.infer<
  typeof GetHyundaiServiceInspectionModelsApiResponseSchema
>;

// POST /v1/service-inspections/reload

export const PostHyundaiServiceInspectionReloadApiArgSchema = z.object({});

export type PostHyundaiServiceInspectionReloadApiArg = z.infer<
  typeof PostHyundaiServiceInspectionReloadApiArgSchema
>;

export const PostHyundaiServiceInspectionReloadApiResponseSchema = z.void();

export type PostHyundaiServiceInspectionReloadApiResponse = z.infer<
  typeof PostHyundaiServiceInspectionReloadApiResponseSchema
>;
